export enum DataSourceColumnStatus {
    Hidden = 0 ,
    Available = 1,
    Selected = 2
}

export class DataSourceColumn {
    code: string ;
    label: string ;
    type: string ;
    status: number ; // 0 Hidden, 1 available, 2 selected
}